// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"CompanyBalanceEditPanel_UsersInfoPanel__Mc3+L","buttonsPanel":"CompanyBalanceEditPanel_buttonsPanel__AvxY5"};